/** Pure helpers for the call window's chat (`routes/MeetingBot/CallChat`). */
import type { ConversationMessage } from '@pipecat-ai/client-react'

/** Plain text of a conversation message; a bot part carries spoken and not-yet-spoken text. */
export function messageText(message: ConversationMessage): string {
  return message.parts
    .map(({ text }) => {
      if (typeof text === 'string') return text.trim()
      if (text && typeof text === 'object' && 'spoken' in text) {
        return `${text.spoken}${text.unspoken}`.trim()
      }
      return ''
    })
    .filter(Boolean)
    .join(' ')
}
